import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import apiMethod from "../../../services/api-service";
import methods from "../../../services/utility";
import Preloading from "../../../components/basics/Preloading";
import back from "../../../assets/images/icons/arrow-right2.svg";
import DeleteModal from "../../../components/deleteModal/DeleteModal";
import DeleteIcon from "../../../assets/images/icons/deleteIcon.svg";
import Paginations from "../../../components/paginaton/Paginations";

const SupplierProducts = () => {
  const { restaurantId, id } = useParams();
  const [loading, setLoading] = useState(false);
  const [gridData, setGridData] = useState([]);
  const [products, setProducts] = useState([]);
  const [selectId, setSelectId] = useState(null);
  const [bulkyProducts, setBulkyProducts] = useState([]);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showSupplierModal, setShowSupplierModal] = useState(false);
  const [filterModel, setFilterModel] = useState({
    SupplierId: id,
    ProductTitle: "",
    size: 10,
    part: 1,
    parts: 0,
    total: 0,
  });

  const [formModel, setFormModel] = useState({
    id: 0,
    SupplierId: id,
    productId: 0,
    maxAmount: 0,
  });

  const [listProducts, setListProducts] = useState({
    restaurantId: restaurantId,
    supplierId: id,
    categoryId: "",
    productType: "",
    natureType: "",
    title: "",
    code: "",
    size: 20,
    part: 1,
  });

  const findProducts = async () => {
    setLoading(true);
    const resp = await apiMethod.findProductForSupplier(
      listProducts.restaurantId,
      listProducts.supplierId,
      listProducts.title,
      listProducts.size,
      listProducts.part
    );
    if (!methods.showApiErrors(resp)) {
      setLoading(false);
      return false;
    }
    setProducts(resp.data);
    setLoading(false);
  };

  const getGridData = async (customPart = null) => {
    const part = customPart ? customPart : filterModel.part;
    setLoading(true);
    const resp = await apiMethod.getSupplierProducts(
      filterModel.SupplierId,
      filterModel.ProductTitle,
      filterModel.size,
      part
    );
    if (!methods.showApiErrors(resp)) {
      setLoading(false);
      return false;
    }
    filterModel.total = resp.total;
    filterModel.parts = methods.calcPageParts(resp.total, filterModel.size);
    filterModel.part = part;
    setFilterModel({ ...filterModel });
    setGridData(resp.data);
    setLoading(false);
  };

  useEffect(() => {
    const bindData = async () => {
      setLoading(true);
      await findProducts();
      await getGridData();
      setLoading(false);
    };
    bindData();
  }, []);

  const resetFilters = () => {
    filterModel.SupplierId = id;
    filterModel.ProductTitle = "";
    filterModel.part = 1;
    filterModel.size = 10;
    filterModel.parts = 0;
    filterModel.total = 0;
    setFilterModel({ ...filterModel });
  };

  const resetForm = () => {
    formModel.SupplierId = id;
    formModel.id = 0;
    formModel.productId = 0;
    formModel.maxAmount = 0;
    setFormModel({ ...formModel });
  };

  const resetListProducts = () => {
    listProducts.categoryId = "";
    listProducts.code = "";
    listProducts.natureType = "";
    listProducts.restaurantId = restaurantId;
    listProducts.size = 20;
    listProducts.part = 1;
    listProducts.supplierId = id;
    listProducts.productType = "";
    listProducts.title = "";
    setListProducts({ ...listProducts });
  };

  const closeSupplierModal = () => {
    setShowSupplierModal(false);
  };

  const closeDeleteModal = () => {
    setShowDeleteModal(false);
    resetForm();
  };

  const callPager = async (i) => {
    setLoading(true);
    setFilterModel({ ...filterModel, part: i });
    await getGridData(i);
    setLoading(false);
  };

  const searchItem = async () => {
    setLoading(true);
    await getGridData();
    setLoading(false);
  };

  const clearSearch = async () => {
    setLoading(true);
    resetFilters();
    await getGridData();
    setLoading(false);
  };

  const searchItemProducts = async () => {
    setLoading(true);
    await findProducts();
    setLoading(false);
  };

  const clearSearchProducts = async () => {
    setLoading(true);
    resetListProducts();
    await findProducts();
    setLoading(false);
  };

  const addProduct = async (item) => {
    formModel.productId = item.id;
    setFormModel({ ...formModel });
    setLoading(true);
    const resp = await apiMethod.createSupplierProduct(formModel);
    if (!methods.showApiErrors(resp)) {
      setLoading(false);
      return false;
    }
    resetListProducts();
    await getGridData();
    await findProducts();
    setLoading(false);
    setShowSupplierModal(false);
  };

  const handleBulky = (item) => {
    setBulkyProducts((prev) => {
      const exists = prev.some((p) => p.productId === item.id);
      if (exists) {
        return prev.filter((p) => p.productId !== item.id);
      } else {
        return [
          ...prev,
          {
            id: 0,
            SupplierId: id,
            productId: item.id,
            maxAmount: 0,
          },
        ];
      }
    });
  };

  const createItemBulky = async () => {
    setLoading(true);
    const resp = await apiMethod.createBulkySupplierProduct(bulkyProducts);
    if (!methods.showApiErrors(resp)) {
      setLoading(false);
      return false;
    }
    resetListProducts();
    await getGridData();
    await findProducts();
    setBulkyProducts([]);
    setLoading(false);
    setShowSupplierModal(false);
  };

  const selectَItemToDelete = (item) => {
    setSelectId(item);
    setShowDeleteModal(true);
  };

  const deleteItem = async () => {
    setLoading(true);
    const resp = await apiMethod.removeSupplierProduct(selectId.id);
    if (!methods.showApiErrors(resp)) {
      setLoading(false);
      return false;
    }
    await getGridData();
    await findProducts();
    resetForm();
    setLoading(false);
    setShowDeleteModal(false);
  };

  const supplierProduct = () => {
    return (
      <>
        {loading && <Preloading></Preloading>}
        {
          <>
            <div className="d-none d-lg-block mb-3">
              <Link
                to={`/warehouse/${restaurantId}/supplierWarehouse`}
                className="text-start mb-3 link back-link"
              >
                <span>
                  <img src={back} className="" alt="return" />
                </span>
                بازگشت
              </Link>
            </div>
            <div className="d-lg-none d-flex justify-content-between align-items-baseline saleheader">
              <div>
                <Link
                  to={`/warehouse/${restaurantId}/supplierWarehouse`}
                  className="link back-link"
                >
                  <span>
                    <img src={back} className="" alt="return" />
                  </span>
                </Link>
                تامین کننده / کالا
              </div>
              <p className="date">{methods.currentDate()}</p>
            </div>
            <div className="saleheader d-none d-lg-block">
              <p>
                تامین کننده / کالا
                <a
                  href={`/wareHouse/${restaurantId}/`}
                  className="link rtlicon me-1"
                  title="برای اطلاعات بیشتر کلیک کنید"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="bi bi-question-circle"></i>
                </a>
              </p>
            </div>
            <div className="salemain mb-3">
              <div className="row align-items-end g-3">
                <div className="col-3">
                  <label htmlFor="title" className="form-label required-label">
                    عنوان
                  </label>
                  <input
                    className="form-control input-form"
                    type="text"
                    aria-label="Add your item here..."
                    style={{ direction: "rtl", textAlign: "right" }}
                    value={filterModel.ProductTitle}
                    onChange={(e) =>
                      setFilterModel({
                        ...filterModel,
                        ProductTitle: e.target.value,
                      })
                    }
                    placeholder="جتسجو کنید..."
                  />
                </div>
                <div className="col-2">
                  <div className="d-flex align-items-center gap-2">
                    <button
                      className="btn-wrap search-btn"
                      onClick={searchItem}
                    >
                      <i className="bi bi-search"></i>
                    </button>
                    <button
                      className="btn-wrap reset-btn"
                      onClick={clearSearch}
                    >
                      <i className="bi bi-arrow-clockwise"></i>
                    </button>
                  </div>
                </div>
                <div class="col-12 col-md-6 col-lg-7">
                  <div class="createButton ">
                    <button
                      class="btn btn-outline-purple custome-btn"
                      type="button"
                      onClick={() => setShowSupplierModal(true)}
                    >
                      <span class="align-middle d-inline-block">
                        افزودن کالا
                      </span>{" "}
                      <i class="bi bi-plus-circle align-middle"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="salemain">
              <span className="d-block text-start fw-bold fs-5">
                کالاهای تامین کننده
              </span>
              <div className="table-responsive warhousetable">
                <table className="table table-md table-custom">
                  <thead className="align-middle">
                    <tr>
                      <th scope="col vertical-center" width="20px">
                        ردیف
                      </th>
                      <th scope="col vertical-center">عنوان</th>
                      <th scope="col vertical-center">کد</th>
                      <th scope="col vertical-center">عملیات</th>
                    </tr>
                  </thead>
                  <tbody className="align-middle">
                    {gridData.map((item, index) => (
                      <tr key={item.id}>
                        <th scope="row">
                          {(filterModel.part - 1) * filterModel.size +
                            index +
                            1}
                        </th>
                        <td>{item.productTitle}</td>
                        <td>{item.productCode}</td>
                        <td>
                          <button
                            onClick={() => selectَItemToDelete(item)}
                            className="button-action"
                            type="button"
                          >
                            <img src={DeleteIcon} alt="Image" />
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                {filterModel.parts > 1 && (
              <div className="pagination justify-content-center mt-5">
                <Paginations
                  total={filterModel.total}
                  size={filterModel.size}
                  onPageChange={callPager}
                />
              </div>
            )}
              </div>
            </div>
          </>
        }
      </>
    );
  };

  const addSupplierProductModal = () => {
    return (
      <div
        className="modal fade show"
        tabIndex="-1"
        role="dialog"
        style={{ display: "block" }}
        onClick={closeSupplierModal}
      >
        <div
          className="modal-dialog modal-lg modal-dialog-centered"
          role="document"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="modal-content px-3">
            <div className="modal-header">
              <h5 className="modal-title">افزودن / ویرایش تامین کننده</h5>
              <button
                type="button"
                className="btn-close"
                aria-label="Close"
                onClick={closeSupplierModal}
              ></button>
            </div>
            <div className="modal-body">
              <div className="row g-1">
                <div className="col-12 col-md-6 col-lg-4">
                  <label htmlFor="searchInput" className="form-label">
                    عنوان
                  </label>
                  <div className="hstack">
                    <input
                      id="searchInput"
                      className="form-control"
                      type="text"
                      aria-label="Add your item here..."
                      style={{ direction: "rtl", textAlign: "right" }}
                      value={listProducts.title}
                      onChange={(e) => {
                        setListProducts({
                          ...listProducts,
                          title: e.target.value,
                        });
                      }}
                    />
                  </div>
                </div>
                <div
                  className="col-2 d-flex align-items-end"
                  style={{ marginBottom: "4px" }}
                >
                  <button
                    type="button"
                    className="btn btn-purple me-1"
                    onClick={searchItemProducts}
                  >
                    <i className="bi bi-search"></i>
                  </button>
                  <button
                    type="button"
                    className="btn btn-outline-info"
                    onClick={clearSearchProducts}
                  >
                    <i className="bi bi-arrow-clockwise"></i>
                  </button>
                </div>
              </div>
              <div className="border rounded mt-4">
                <p className="bg-light rounded-top p-3">
                  افزودن کالا در تامین کننده
                </p>
                <div className="table-responsive saletable m-3">
                  <table className="table table-striped table-md align-middle">
                    <thead className="">
                      <tr>
                        <th scope="col vertical-center" width="20px">
                          ردیف
                        </th>
                        <th scope="col vertical-center">عنوان</th>
                        <th scope="col vertical-center" width="50px">
                          عملیات
                        </th>
                      </tr>
                    </thead>
                    <tbody className="">
                      {products.map((item, index) => (
                        <tr key={item.id}>
                          <th scope="row">
                            {(listProducts.part - 1) * listProducts.size +
                              index +
                              1}
                          </th>
                          <td>
                            <div className="row g-3">
                              <div className="col-5 d-flex justify-content-end">
                                <input
                                  id={item.id}
                                  type="checkbox"
                                  className="me-2"
                                  onChange={() => handleBulky(item)}
                                />
                              </div>
                              <div className="col-7 d-flex justify-content-start">
                                <label htmlFor={item.id}>{item.title}</label>
                              </div>
                            </div>
                          </td>
                          <td>
                            <button
                              type="button"
                              className="btn btn-sm btn-purple"
                              onClick={() => addProduct(item)}
                            >
                              افزودن
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  <div class="d-flex align-items-center justify-content-end gap-3 mt-4">
                    <button
                      type="button"
                      class="btn custome-btn btn-link-purple"
                      onClick={closeSupplierModal}
                    >
                      انصراف
                    </button>
                    <button
                      type="button"
                      class="btn custome-btn btn-purple"
                      onClick={createItemBulky}
                    >
                      ثبت و ذخیره
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      {supplierProduct()}
      {showSupplierModal && addSupplierProductModal()}
      {showDeleteModal && (
        <DeleteModal
          showModal={showDeleteModal}
          closeModal={closeDeleteModal}
          deleteItem={deleteItem}
          text={"کالای تامین کننده"}
        />
      )}
    </>
  );
};

export default SupplierProducts;
